const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "GCORES PUBLISHING"
const desc =
  "GCORES PUBLISHING是由机核组建的独立游戏发行业务，旨在从组队与孵化开始，为中小独立游戏开发组提供包含咨询，融资，商务，营销，美术，本地化，线上线下展会，QA，实体周边开发等全方位发行服务。"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    keekPresskitLink: "https://www.gcores.com",
    keekSteamLink: "https://store.steampowered.com/app/2088080/KEEK/",
    catoPressLink: "https://site.gcores.com/cato/",
    catoSteamLink: "https://store.steampowered.com/app/1999520/Cato/",
  },
}
